import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const firmaImporterSelectors = importerSelectors(
  'firma.importer',
);

export default firmaImporterSelectors;
